const asyncLocalforage = import('localforage').then(async (localforage) => {
  if (typeof window === 'object') await localforage.default.ready()
  return localforage.default
})

export default asyncLocalforage
